import { AudioManager } from "../../AudioManager";
import { GameManager } from "../../GameManager";
import { GameVars } from "../../GameVars";
import { ButtonWithText } from "../../utils/ButtonWithText";
import { BootScene } from "../BootScene";

export class ShopItemCapsule extends Phaser.GameObjects.Container {

    public id: number;

    private itemType: string;
    private equipButton: ButtonWithText;
    private buyButton: ButtonWithText;
    private equippedButton: Phaser.GameObjects.Container;
    private price: number;
    private itemImage: Phaser.GameObjects.Image;
    private equippedFX: Phaser.GameObjects.Image;
    private itemNameLabel: Phaser.GameObjects.Text;

    constructor(scene: Phaser.Scene, itemType: string, id: number) {

        super(scene);

        this.itemType = itemType;
        this.id = id;

        let boxImageTextureName: string;
        let itemImageTextureName: string;
        let itemImageTextureAtlasName: string;
        let itemImageScale: number;
        let buttons_py: number;
        let buttonsScale: number;
        let fxScale: number;

        let itemName_py: number;
        let itemNameFontSize: string;
        let name: string;

        const gameText = this.scene.game.cache.json.get("game-text");

        if (itemType === ShopItem.BOARD) {
            boxImageTextureName = "box_table";
            itemImageTextureName = "board_" + this.id;
            itemImageTextureAtlasName = this.id < 5 ? "texture_atlas_2" : "texture_atlas_3";
            itemImageScale = .25;
            buttons_py = 200;
            buttonsScale = .8;
            fxScale = 1.4;
            itemName_py = -140 + (BootScene.textYgap * -65);
            itemNameFontSize = "32px";
            name = gameText.SHOP_ITEMS_BOARDS[this.id - 1];
        } else {
            boxImageTextureName = "box_striker";
            itemImageTextureName = "striker_" + this.id;
            itemImageTextureAtlasName = "texture_atlas_1";
            itemImageScale = .9;
            buttons_py = 150;
            buttonsScale = .75;
            fxScale = .9;
            itemName_py = -90 + (BootScene.textYgap * -65);
            itemNameFontSize = "25px";
            name = gameText.SHOP_ITEMS_STRIKERS[this.id - 1];
        }

        this.equippedFX = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "box_equipped_fx");
        this.equippedFX.setScale(fxScale);
        this.add(this.equippedFX);

        this.scene.tweens.add({
            targets: this.equippedFX,
            alpha: .6,
            ease: Phaser.Math.Easing.Cubic.InOut,
            duration: 350,
            repeat: -1,
            yoyo: true
        });

        const backgroundImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", boxImageTextureName);
        this.add(backgroundImage);

        this.itemNameLabel = new Phaser.GameObjects.Text(this.scene, 0, itemName_py, name, { fontFamily: "Wolf-Sans-Regular", fontSize: itemNameFontSize, color: "#FFFFFF" });
        this.itemNameLabel.setOrigin(.5,BootScene.originY);
        this.add(this.itemNameLabel);

        this.itemImage = new Phaser.GameObjects.Image(this.scene, 0, 35, itemImageTextureAtlasName, itemImageTextureName);
        this.itemImage.setScale(itemImageScale);
        this.add(this.itemImage);

        const equipButtonImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_orange");
        const equipButtonLabel = new Phaser.GameObjects.Text(this.scene, 0, -5 + (BootScene.textYgap * -70), gameText.EQUIP, { fontFamily: "Teko-Medium", fontSize: "60px", color: "#FFFFFF" });
        equipButtonLabel.setOrigin(.5,BootScene.originY);

        this.equipButton = new ButtonWithText(this.scene, equipButtonImage, equipButtonLabel, this.onClickEquipped, this);
        this.equipButton.y = buttons_py;
        this.equipButton.setScale(buttonsScale);
        this.add(this.equipButton);

        const equippedImage = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_grey");
        const equippedText = new Phaser.GameObjects.Text(this.scene, 0, -5 + (BootScene.textYgap * -80), gameText.EQUIPPED, { fontFamily: "Teko-Medium", fontSize: "60px", color: "#FFFFFF" });
        equippedText.setOrigin(.5,BootScene.originY);

        this.equippedButton = new Phaser.GameObjects.Container(this.scene);
        this.equippedButton.y = buttons_py;
        this.equippedButton.setScale(buttonsScale);
        this.add(this.equippedButton);

        this.equippedButton.add(equippedImage);
        this.equippedButton.add(equippedText);

        this.price = GameManager.getItemPrice(this.itemType, this.id);

        const buyButtonImange = new Phaser.GameObjects.Image(this.scene, 0, 0, "texture_atlas_1", "btn_orange");
        const buyButtonText = new Phaser.GameObjects.Text(this.scene, 40, -5 + (BootScene.textYgap * -64), GameVars.formatNumber(this.price), { fontFamily: "Teko-Medium", fontSize: "54px", color: "#FFFFFF" });
        buyButtonText.setOrigin(.5,BootScene.originY);

        const gem = new Phaser.GameObjects.Image(this.scene, -55, -4, "texture_atlas_1", "icon_top_gems");
        gem.setScale(.85);

        this.buyButton = new ButtonWithText(this.scene, buyButtonImange, buyButtonText, this.onClickBuy, this, gem);
        this.buyButton.y = buttons_py;
        this.buyButton.setScale(buttonsScale);
        this.add(this.buyButton);

        this.setStatus();
    }

    public setStatus(id?: number): void {

        const gameText = this.scene.game.cache.json.get("game-text");

        if (id) {

            this.id = id;

            if (this.itemType === ShopItem.BOARD) {

                let itemImageTextureAtlasName = this.id < 5 ? "texture_atlas_2" : "texture_atlas_3";
                this.itemImage.setTexture(itemImageTextureAtlasName, "board_" + this.id);

                this.itemNameLabel.text = gameText.SHOP_ITEMS_BOARDS[this.id - 1];

                if (this.itemNameLabel.text.length > 9) {
                    this.itemNameLabel.setFontSize(28);
                } else {
                    this.itemNameLabel.setFontSize(32);
                }

            } else {

                this.itemImage.setTexture("texture_atlas_1", "striker_" + this.id);

                this.itemNameLabel.text = gameText.SHOP_ITEMS_STRIKERS[this.id - 1];

                if (this.itemNameLabel.text.length > 9) {
                    this.itemNameLabel.setFontSize(21);
                } else {
                    this.itemNameLabel.setFontSize(25);
                }
            }
        }

        const status = GameManager.getItemStatus(this.itemType, this.id);

        switch (status) {

            case ShopItemStatus.PURCHASED:

                this.equipButton.visible = true;
                this.equippedButton.visible = false;
                this.buyButton.visible = false;
                this.equippedFX.visible = false;

                break;

            case ShopItemStatus.NOT_PURCHASED:

                this.equipButton.visible = false;
                this.equippedButton.visible = false;
                this.buyButton.visible = true;
                this.equippedFX.visible = false;

                this.price = GameManager.getItemPrice(this.itemType, this.id);
                this.buyButton.label.text = GameVars.formatNumber(this.price);

                if (this.price > GameVars.gameData.gems) {
                    this.buyButton.alpha = .45;
                    this.buyButton.disable();
                }

                break;

            case ShopItemStatus.EQUIPPED:

                this.equipButton.visible = false;
                this.equippedButton.visible = true;
                this.buyButton.visible = false;
                this.equippedFX.visible = true;

                break;

            default:
                break;
        }
    }

    private onClickEquipped(): void {

        AudioManager.playSound("click_btn");

        GameManager.equipItem(this.itemType, this.id);
    }

    private onClickBuy(): void {

        AudioManager.playSound("click_btn");

        GameManager.buyItem(this.itemType, this.id);
    }
}
